export default {
    ACCESS_TOKEN: 'ACCESS_TOKEN',

    LEVEL_ONE_MATH: 'LEVEL_ONE_MATH',
    LEVEL_ONE_WORDS: 'LEVEL_ONE_WORDS',
    LEVEL_TWO_MATH: 'LEVEL_TWO_MATH',
    LEVEL_TWO_WORDS: 'LEVEL_TWO_WORDS',
}
